<script>
export default {

  data: function () {
    return {
      checked : false,
    };
  },
  methods: {
    toggle: function () {
      this.checked = !this.checked;
    }
  },
}
</script>



// WEBPACK FOOTER //
// assets/js/components/Newsletter.vue